/*
 * Movers Bag · compra secundaria en la ficha de producto.
 * <mb-compra-espejo> replica el precio y el estado del botón principal de Dawn
 * y, al pulsarlo, delega en ese botón (misma variante, mismo formulario).
 * Con data-flotante muestra la barra fija en móvil cuando el botón principal
 * sale de pantalla.
 */
if (!customElements.get('mb-compra-espejo')) {
  customElements.define(
    'mb-compra-espejo',
    class MbCompraEspejo extends HTMLElement {
      connectedCallback() {
        this.productInfo = document.querySelector('product-info[id^="MainProduct-"]');
        if (!this.productInfo) return;

        this.sectionId = this.productInfo.dataset.section;
        this.boton = this.querySelector('[data-mb-boton]');
        this.precio = this.querySelector('[data-mb-precio]');
        this.etiqueta = this.querySelector('[data-mb-etiqueta]');

        this.sincronizar = this.sincronizar.bind(this);
        this.boton?.addEventListener('click', this.comprar.bind(this));

        this.observador = new MutationObserver(this.sincronizar);
        this.observarOrigen();
        this.sincronizar();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          // Dawn reemplaza el bloque de precio y botón al cambiar de variante.
          this.cancelarVariante = subscribe(PUB_SUB_EVENTS.variantChange, () => {
            requestAnimationFrame(() => {
              this.observarOrigen();
              this.sincronizar();
            });
          });
        }

        if (this.hasAttribute('data-flotante')) this.iniciarFlotante();
      }

      disconnectedCallback() {
        this.observador?.disconnect();
        this.visibilidad?.disconnect();
        if (this.cancelarVariante) this.cancelarVariante();
        document.body.classList.remove('mb-barra-visible');
      }

      get botonPrincipal() {
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      get precioPrincipal() {
        return document.getElementById(`price-${this.sectionId}`);
      }

      observarOrigen() {
        this.observador.disconnect();
        const opciones = { attributes: true, childList: true, subtree: true, characterData: true };
        if (this.botonPrincipal) this.observador.observe(this.botonPrincipal, opciones);
        if (this.precioPrincipal) this.observador.observe(this.precioPrincipal, opciones);
      }

      sincronizar() {
        const principal = this.botonPrincipal;
        if (principal && this.boton) {
          const desactivado = principal.hasAttribute('disabled') || principal.getAttribute('aria-disabled') === 'true';
          this.boton.disabled = desactivado;
          const texto = principal.querySelector('span')?.textContent.trim();
          if (texto && this.etiqueta) this.etiqueta.textContent = texto;
        }
        const precio = this.precioPrincipal;
        if (precio && this.precio) this.precio.innerHTML = precio.innerHTML;
      }

      comprar(evento) {
        evento.preventDefault();
        const principal = this.botonPrincipal;
        if (!principal || principal.disabled) return;
        principal.click();
      }

      iniciarFlotante() {
        const principal = this.botonPrincipal;
        if (!principal || !('IntersectionObserver' in window)) return;

        const estado = { principal: true, cierre: false };
        const aplicar = () => {
          const mostrar = !estado.principal && !estado.cierre;
          this.classList.toggle('is-visible', mostrar);
          this.toggleAttribute('inert', !mostrar);
          this.setAttribute('aria-hidden', String(!mostrar));
          document.body.classList.toggle('mb-barra-visible', mostrar);
        };

        this.visibilidad = new IntersectionObserver((entradas) => {
          entradas.forEach((entrada) => {
            if (entrada.target === principal) estado.principal = entrada.isIntersecting;
            else estado.cierre = entrada.isIntersecting;
          });
          aplicar();
        });
        this.visibilidad.observe(principal);
        document.querySelectorAll('.mb-cierre').forEach((cierre) => this.visibilidad.observe(cierre));
        aplicar();
      }
    }
  );
}
